
import dotProp from "dot-prop-immutable"
import { INIT_FORM, UPDATE_VALUE } from "products/types"

export const types = {
    INIT_FORM: "INIT_FORM",
    VALIDATE_FORM: "VALIDATE_FORM",
    SET_ERROR: "SET_ERROR",
    WARNING_FORM: "WARNING_FORM",
}

const initialState = {}

const extractErrorName = (key: string): string => {
    let sliceStart: number
    const splitKey = key.split(".")
    const secondEl = parseInt(splitKey[1])

    // look for the next word after the first word
    if (isNaN(secondEl)) {
        sliceStart = 1
    } else { sliceStart = 2 }

    const result = splitKey.slice(sliceStart).join(".")
    return result
}

const renameErrors = (obj) =>
    Object.keys(obj).reduce((acc, key) => ({
        ...acc,
        ...{ [extractErrorName(key)]: obj[key] }
    }), {}
    );

// REDUCERS
export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_FORM:
            const values = action.payload.values ?? action.payload.data
            return { ...state, [action.payload.form]: values }
        case UPDATE_VALUE:
            if (action.payload.value === null || action.payload.value === '') {
                return dotProp.delete(state, action.payload.name)
            } else if (Array.isArray(action.payload.value) && action.payload.value.length > 1 && (action.payload.value[0] === null || action.payload.value[0] === '')) {
                action.payload.value.shift()
            }
            return dotProp.set(state, action.payload.name, action.payload.value)
        case types.VALIDATE_FORM:
            const eee = action.payload.errors ? Object.keys(action.payload.errors).map(k => {
                return dotProp.set({}, k, action.payload.errors[k])
            }) : null
            return {
                ...state, [action.payload.form]: {
                    ...state[action.payload.form],
                    errors: action.payload.errors ? renameErrors(action.payload.errors) : {},
                    errors_undot: eee,
                }
            }
        case types.SET_ERROR:
            const errors = { ...state[action.payload.form]['errors'], [action.payload.field]: action.payload.error }
            return { ...state, [action.payload.form]: { ...state[action.payload.form], errors, } }
        default:
            return state;
    }
}

// SELECTORS
export const selectFormValues = (state, formName) => state.form?.[formName] ?? {}
export const selectFormValue = (state, formName, name) => selectFormValues(state, formName)[name]
export const selectFormErrors = (state, formName) => selectFormValues(state, formName)['errors'] || {}
export const selectFormErrorsUndot = (state, formName) => selectFormValues(state, formName)['errors_undot'] || []

// ACTIONS
export function initForm(form: string, values) {
    return {
        type: types.INIT_FORM,
        payload: { form, values },
    }
}


export const setError = (form: string, field: string, error: string) => {
    return {
        type: types.SET_ERROR,
        payload: {
            form,
            field,
            error,
        }
    }
}


export type UpdateInputValueSpecialType = 'none' | 'do-not-save-history'
export type updateInputValueProps = {
    form: string
    name: string
    value: any
    special: UpdateInputValueSpecialType
}
export function updateInputValue(form: string, name: string, value: any, special: UpdateInputValueSpecialType = 'none') {
    return {
        type: "UPDATE_VALUE",
        payload: {
            name: `${form}.${name}`,
            form: form,
            value,
            special,
        }
    }
}

export const showFormErrors = (form: string, errors, toast = true) => {
    window['store'].dispatch({
        type: types.VALIDATE_FORM,
        payload: {
            form,
            errors,
        }
    })
}

export const clearFormErrors = (form: string) => {
    window['store'].dispatch({
        type: types.VALIDATE_FORM,
        payload: {
            form,
            errors: null,
            errors_undot: null,
        }
    })
}
